<template>
	<div class="form-container">
		<h3 class="vrnu-headline">Profil bearbeiten</h3>
    <vrnu-text-box v-bind:variant="'info'">
      Auf dieser Seite können Sie Änderungen an Ihrem Benutzerprofil vornehmen. Bitte beachten Sie, dass diese Änderungen erst wirksam werden, wenn Sie sich das nächste Mal am System einloggen.
    </vrnu-text-box>
    <b-form v-on:submit.prevent="save">
			<b-container class="no-padding">
				<b-row>
					<b-col>
						<b-form-group
							label="Vorname"
							label-for="firstname">
							<b-form-input id="firstname"
								type="text"
								placeholder="Vorname"
								v-model.trim="user.firstname"
								v-validate="'required'"
								data-vv-name="Vorname"
								:class="{'has-error': errors.has('Vorname')}">
							</b-form-input>
							<p v-if="errors.has('Vorname')" class="error-message">
								{{ errors.first('Vorname') }}
						    </p>
						</b-form-group>
						<b-form-group
							label="Nachname"
							label-for="lastname">
							<b-form-input id="lastname"
								type="text"
								placeholder="Nachname"
								v-model.trim="user.lastname"
								v-validate="'required'"
								data-vv-name="Nachname"
								:class="{'has-error': errors.has('Nachname')}">
							</b-form-input>
							<p v-if="errors.has('Nachname')" class="error-message">
								{{ errors.first('Nachname') }}
						    </p>
						</b-form-group>
						<b-form-group
							label="Passwort ändern"
							label-for="changePassword">
							<b-form-checkbox id="changePassword"
						                     v-model.trim="changePassword"
						                     value="true"
						                     unchecked-value="false">
						      Passwort ändern
						    </b-form-checkbox>
						</b-form-group>			
						<div 	v-if="changePassword == 'true'">
							<p>Geben Sie Ihre aktuelles Passwort und Ihr neues Passwort ein, um Ihre Zugangsdaten zu ändern.</p>
							<b-form-group
								label="Aktuell"
								label-for="currentPassword">
								<b-form-input id="currentPassword"
									type="password"
									placeholder=""
									v-model.trim="password.currentPassword"
									v-validate="'required'"
									data-vv-name="Aktuell"
									:class="{'has-error': errors.has('Aktuell')}">
								</b-form-input>
								<p v-if="errors.has('Aktuell')" class="error-message">
									{{ errors.first('Aktuell') }}
							    </p>
							</b-form-group>
							<b-form-group
								label="Neu"
								label-for="newPassword">
								<b-form-input id="newPassword"
									type="password"
									placeholder=""
									v-model.trim="password.newPassword"
									v-validate="'required|checkPasswordForValidity'"
									data-vv-name="Neu"
									:class="{'has-error': errors.has('Neu')}">
								</b-form-input>
								<p v-if="errors.has('Neu')" class="error-message">
									{{ errors.first('Neu') }}
							    </p>
							</b-form-group>
						</div>
						<div class="space20"></div>			
					</b-col>
				</b-row>
			</b-container>
			<b-button type="submit" class="vrnu-button" variant="primary">Speichern</b-button>
			<b-button type="reset" variant="secondary">Zurücksetzen</b-button>
		</b-form>		
		
		<!-- Info modal -->
		<b-modal ref="infoModal" centered hide-footer title="Info">
			<p>{{ infoModalMessage }}</p>
			<slot name="modal-ok">
				<b-button class="vrnu-button" v-on:click="$refs.infoModal.hide()">Ok</b-button>
			</slot>
	    </b-modal>	    
	</div>
</template>

<script>
// Organize imports
import { checkPasswordForValidity } from '../../validator/checkPasswordForValidity.js';

export default {
	data: function() {
		return {
			updateId: null,
			user: {
				firstname: '',
				lastname: '',
			},
			password: {
				currentPassword: '',
				newPassword: '',
			},
			changePassword: false,
			infoModalMessage: '',
		};
	},
	computed: {
	},
	methods: {
		save: function() {
			this.$validator.validate().then(result => {
				if (result) {
					var data = {
						firstname: this.user.firstname,
						lastname: this.user.lastname,
					};
					
					// Add password data if password shall be updated
					if(this.changePassword) {
						data.changePassword = this.changePassword;
						data.currentPassword = this.password.currentPassword;
						data.newPassword = this.password.newPassword;
					}

					// Update the customer
	 				this.$http.put('users/updateByUser/' + this.updateId, data).then(result => {
	 					this.openInfoModal("Die Änderungen an Ihrem Benutzerprofil wurden erfolgreich gespeichert.");
	 					this.changePassword = false;
	 					this.loadUserForUpdate();
					}, response => {
						// console.log(response);
						if(typeof response.body.msg !== 'undefined') {
		 					this.openInfoModal(response.body.msg);														
						} else {
		 					this.openInfoModal("Beim Speichern der Änderungen an Ihrem Benutzerprofil ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");							
						}
	 				});				
				}
			});
		},
		loadUserForUpdate: function() {
			// Get customer from server
			this.$http.get('auth/user').then(user => {
				this.user = {
					firstname: user.body.data.firstname,
					lastname: user.body.data.lastname,
				};
				
				this.updateId = user.body.data._id;
			}, response => {
				// TODO: find a solution
				this.openInfoModal("Beim Laden Ihres Benutzeraccounts ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator.");
			});
		},
		openInfoModal: function(message) {
			this.infoModalMessage = message;
			this.$refs.infoModal.show();
		},
		closeModal: function() {
			this.$emit('closeModal');
		},
		clearPasswordFieldsContent: function() {
			this.password = {
				currentPassword: '',
				newPassword: '',
			};
		},
	},
	watch: {
		changePassword: function() {
			this.clearPasswordFieldsContent();
		},
	},
	mounted: function() {
		this.loadUserForUpdate();
		
		// Extend the validator
		this.$validator.extend('checkPasswordForValidity', checkPasswordForValidity);
	},
}
</script>

<style>
.form-container {
	padding: 5px;
}
.mb-3 {
	margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/01_auth/Profile.vue